export default __webpack_public_path__ + "static/Blue-bc1019c502f9c36cc29a449a2b163f5f.svg";